import React from 'react';

function FilterOption({ name, title, id, checked = false, onChange }) {
    const handleChange = () => {
        window.dataLayer.push({
            event: 'survey_demographic_click',
            value: id,
            page: window.location.pathname,
        });

        onChange();
    };
    return (
        <div className="filter-option">
            <input
                className="sr-only"
                type="radio"
                id={id}
                name={name}
                value={id}
                checked={checked}
                onChange={handleChange}
            />
            <label className="filter-btn" htmlFor={id}>
                {title}
            </label>
        </div>
    );
}

export default FilterOption;
